import {
  AppSyncFarm,
  AppSyncFarmToken,
  MonitorVaults,
} from 'common/models/farm';
import React from 'react';
import { AppSyncUserInfo } from 'common/models/userInfo';
import { Link } from 'gatsby';
import GetStarted from './GetStarted';
import Deposit from './Deposit';
import { ChainId } from 'constants/constants';
import { TokenUtils } from 'utils/tokenUtils';
import Manage from './Manage';
import Withdraw from './Withdraw';

type Props = {
  tab: string;
  accountAddress: string;
  token: AppSyncFarmToken | undefined;
  pairedToken: AppSyncFarmToken | undefined;
  vault: AppSyncFarm | undefined;
  farms: AppSyncFarm[];
  userInfoLoading: boolean;
  userInfo: AppSyncUserInfo;
  claiming: boolean;
  monitorVaults: MonitorVaults[] | [];
  chainId: ChainId;
  refetchUserInfo: () => Promise<void>;
  updatePool: (poolId: number) => Promise<void>;
  urlTab: string | null;
};

const Vault: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState(
    !props.userInfoLoading ? props.tab : null
  );
  const depositToken = props.token;
  const pairedToken = props.pairedToken;
  const vault = props.vault;

  const farmUserInfo = vault
    ? TokenUtils.getFarmUserInfo(vault, props.userInfo)
    : undefined;

  const goBackLink = props.urlTab ? `/?tab=${props.urlTab}` : '/';

  return (
    <>
      <div className="primary-color font-semibold text-left pt-3">
        <Link to={goBackLink} className="go-back">
          <span className="arrow-left-green"> </span> Back to Vaults
        </Link>
      </div>
      <div className="text-center pt-6 primary-text-color">
        {tab === 'Get Started' && depositToken && (
          <GetStarted
            farms={props.farms}
            monitorVaults={props.monitorVaults}
            depositToken={depositToken}
            onGetStarted={() => setTab('Deposit')}
            chainId={props.chainId}
          />
        )}
        {tab?.toLocaleLowerCase() === 'deposit' && (
          <Deposit
            depositToken={depositToken}
            pairedToken={pairedToken}
            farms={props.farms}
            userInfoLoading={props.userInfoLoading}
            userInfo={props.userInfo}
            claiming={props.claiming}
            monitorVaults={props.monitorVaults}
            chainId={props.chainId}
            handleDepositComplete={() => void props.refetchUserInfo()}
            handleModalClose={() => setTab('Manage')}
            refetchFarmUserInfo={props.refetchUserInfo}
            updatePool={props.updatePool}
            accountAddress={props.accountAddress}
          />
        )}
        {tab?.toLocaleLowerCase() === 'manage' && vault && (
          <Manage
            farm={vault}
            farmUserInfo={farmUserInfo}
            loadingUserInfo={false}
            onDepositOpen={() => {
              setTab('Deposit');
            }}
            onWithdrawOpen={() => {
              setTab('Withdraw');
            }}
            refetchUserInfo={props.refetchUserInfo}
            updatePool={props.updatePool}
            chainId={props.chainId}
          />
        )}
        {tab?.toLocaleLowerCase() === 'withdraw' && vault && (
          <Withdraw
            accountAddress={props.accountAddress}
            farm={vault}
            farmUserInfo={farmUserInfo}
            farmUserInfoLoading={false}
            refetchFarmUserInfo={props.refetchUserInfo}
            updatePool={props.updatePool}
          />
        )}
      </div>
    </>
  );
};

export default Vault;
